import Mainlogo from './assets/img/Creative exterior _LOGO.png';
// import Mainlogo from './assets/img/Mainlogo.jpg';
import heroBG from './assets/img/hero-bg.jpg';
import aboutPic from './assets/img/about.jpg';
import client1 from "./assets/img/clients/client-1.png";
import client2 from "./assets/img/clients/client-2.png";
import client3 from "./assets/img/clients/client-3.png";
import client4 from "./assets/img/clients/client-4.png";
import client5 from "./assets/img/clients/client-5.png";
import client6 from "./assets/img/clients/client-6.png";
import client7 from "./assets/img/clients/client-7.png";
import client8 from "./assets/img/clients/client-8.png";
import ctabg from "./assets/img/cta-bg.jpg";
import portfolio1 from "./assets/img/MyPic/p1.jpg";
import portfolio2 from "./assets/img/MyPic/p2.jpg";
import portfolio3 from "./assets/img/MyPic/p3.jpg";
import portfolio4 from "./assets/img/MyPic/p4.jpg";
import portfolio5 from "./assets/img/MyPic/p5.jpg";
import portfolio6 from "./assets/img/MyPic/p6.jpg";
import portfolio7 from "./assets/img/MyPic/p7.webp";
import portfolio8 from "./assets/img/MyPic/p8.webp";
import portfolio9 from "./assets/img/MyPic/p9.jpg";
import team1 from "./assets/img/team/team-1.jpg";
import team2 from "./assets/img/team/team-2.jpg";
import team3 from "./assets/img/team/team-3.jpg";
import { useState } from 'react';




function App() {

  const [View, setView] = useState("ALL")
  return (
    <div className="App">
      <body class="index-page">

        <header id="header" class="header fixed-top">

          <div class="topbar d-flex align-items-center">
            <div class="container d-flex justify-content-center justify-content-md-between">
              <div class="contact-info d-flex align-items-center">
                <i class="bi bi-envelope d-flex align-items-center"><a href="mailto:info@creativeexterior.in">info@creativeexterior.in</a></i>
                <i class="bi bi-phone d-flex align-items-center ms-4"> <a href={`tel:704-399-2106`}><span>+91 704-399-2106</span></a></i>
              </div>
              <div class="social-links d-none d-md-flex align-items-center">
                {/* <a href="#" class="twitter"><i class="bi bi-twitter-x"></i></a> */}
                <a href="https://www.facebook.com/share/1MBeAe9MDv/" class="facebook"><i class="bi bi-facebook"></i></a>
                <a href="https://www.instagram.com/creativeexterior/" class="instagram"><i class="bi bi-instagram"></i></a>
                {/* <a href="#" class="linkedin"><i class="bi bi-linkedin"></i></a> */}
              </div>
            </div>
          </div>

          <div class="branding d-flex align-items-center">

            <div className="container position-relative d-flex align-items-center justify-content-between">
              <a href="/" className="logo d-flex align-items-center">
                <img src={Mainlogo} alt="Site Logo" />
                <h1 className="sitename">Creative Exterior</h1>
              </a>

              <nav id="navmenu" className="navmenu">
                <ul>
                  <li><a href="#hero" className="active">Home</a></li>
                  <li><a href="#about">About</a></li>
                  <li><a href="#services">Services</a></li>
                  {/* <li><a href="#portfolio">Portfolio</a></li> */}
                  {/* <li><a href="#team">Team</a></li> */}
                  <li><a href="#contact">Contact</a></li>
                </ul>
                <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
              </nav>
            </div>

          </div>

        </header>

        <main class="main">


          <section id="hero" class="hero section dark-background">

            <img src={heroBG} alt="" />

            <div class="container" data-aos-delay="100">
              <div class="row justify-content-start">
                <div class="col-lg-8">
                  {/* "Creative Exterior & Interior" is a design and renovation company specializing in both exterior and interior design solutions. They focus on enhancing living and commercial spaces with stylish, functional, and aesthetically pleasing designs. */}
                  {/* <h2>Creative Exterior & Interior</h2> */}
                  <p>Welcome to Creative Exterior <br />your trusted partner in enhancing spaces with innovative interior, exterior, and netting solutions. With a commitment to quality, durability, and design excellence, we deliver customized solutions that not only look elegant but also add long-lasting value to your property.</p>
                  <a href="#about" class="btn-get-started">Get Started</a>
                </div>
              </div>
            </div>

          </section>


          <section id="about" class="about section">


            <div class="container section-title" >
              <span>About Us<br /></span>
              <h2>About Us<br /></h2>
              <p>At Creative Exterior, we specialize in transforming both indoor and outdoor spaces with creative designs and superior craftsmanship. With years of expertise in design & fabrication, civil work, interior projects, and modern netting systems, our team ensures every project reflects precision, style, and functionality.</p>
            </div>

            <div class="container">

              <div class="row gy-4">

                <div class="col-lg-6 order-1 order-lg-2" data-aos-delay="100">
                  <img src={aboutPic} class="img-fluid" alt="" />
                </div>

                <div class="col-lg-6 order-2 order-lg-1 content" data-aos-delay="200">
                  <h3> Whether it’s designing robust exteriors,</h3>
                  <p class="fst-italic">
                    crafting elegant interiors, or providing safe and stylish netting solutions,
                    we aim to create spaces that match your lifestyle and comfort.
                  </p>
                  <ul>
                    <li><i class="bi bi-check-circle"></i> <span>Quality Materials</span></li>
                    <li><i class="bi bi-check-circle"></i> <span>Innovative Designs</span></li>
                    <li><i class="bi bi-check-circle"></i> <span>On-time Execution</span></li>
                    <li><i class="bi bi-check-circle"></i> <span>Customer Satisfaction</span></li>
                  </ul>
                  <a href="#" class="read-more"><span>Read More</span><i class="bi bi-arrow-right"></i></a>
                </div>

              </div>

            </div>

          </section>

          {/* 
          <section id="cards" class="cards section">

            <div class="container">

              <div class="row no-gutters">

                <div class="col-lg-4 col-md-6 card" data-aos-delay="100">
                  <span>01</span>
                  <h4>Lorem Ipsum</h4>
                  <p>Ulamco laboris nisi ut aliquip ex ea commodo consequat. Et consectetur ducimus vero placeat</p>
                </div>

                <div class="col-lg-4 col-md-6 card" data-aos-delay="200">
                  <span>02</span>
                  <h4>Repellat Nihil</h4>
                  <p>Dolorem est fugiat occaecati voluptate velit esse. Dicta veritatis dolor quod et vel dire leno para dest</p>
                </div>

                <div class="col-lg-4 col-md-6 card" data-aos-delay="300">
                  <span>03</span>
                  <h4> Ad ad velit qui</h4>
                  <p>Molestiae officiis omnis illo asperiores. Aut doloribus vitae sunt debitis quo vel nam quis</p>
                </div>

                <div class="col-lg-4 col-md-6 card" data-aos-delay="400">
                  <span>04</span>
                  <h4>Repellendus molestiae</h4>
                  <p>Inventore quo sint a sint rerum. Distinctio blanditiis deserunt quod soluta quod nam mider lando casa</p>
                </div>

                <div class="col-lg-4 col-md-6 card" data-aos-delay="400">
                  <span>05</span>
                  <h4>Sapiente Magnam</h4>
                  <p>Vitae dolorem in deleniti ipsum omnis tempore voluptatem. Qui possimus est repellendus est quibusdam</p>
                </div>

                <div class="col-lg-4 col-md-6 card" data-aos-delay="600">
                  <span>06</span>
                  <h4>Facilis Impedit</h4>
                  <p>Quis eum numquam veniam ea voluptatibus voluptas. Excepturi aut nostrum repudiandae voluptatibus corporis sequi</p>
                </div>

              </div>

            </div>

          </section>


       <section id="clients" class="clients section light-background">

            <div class="container">

              <div class="swiper init-swiper">
                <script type="application/json" class="swiper-config">
                  {
                    "loop": true,
                  "speed": 600,
                  "autoplay": {
                    "delay": 5000
            },
                  "slidesPerView": "auto",
                  "pagination": {
                    "el": ".swiper-pagination",
                  "type": "bullets",
                  "clickable": true
            },
                  "breakpoints": {
                    "320": {
                    "slidesPerView": 2,
                  "spaceBetween": 40
              },
                  "480": {
                    "slidesPerView": 3,
                  "spaceBetween": 60
              },
                  "640": {
                    "slidesPerView": 4,
                  "spaceBetween": 80
              },
                  "992": {
                    "slidesPerView": 6,
                  "spaceBetween": 120
              }
            }
          }
                </script>
                <div class="swiper-wrapper align-items-center">
                  <div class="swiper-slide"><img src={client1} class="img-fluid" alt="" /></div>
                  <div class="swiper-slide"><img src={client2} class="img-fluid" alt="" /></div>
                  <div class="swiper-slide"><img src={client3} class="img-fluid" alt="" /></div>
                  <div class="swiper-slide"><img src={client4} class="img-fluid" alt="" /></div>
                  <div class="swiper-slide"><img src={client5} class="img-fluid" alt="" /></div>
                  <div class="swiper-slide"><img src={client6} class="img-fluid" alt="" /></div>
                  <div class="swiper-slide"><img src={client7} class="img-fluid" alt="" /></div>
                  <div class="swiper-slide"><img src={client8} class="img-fluid" alt="" /></div>
                </div>
              </div>

            </div>

          </section> */}


          {/* <section id="services" class="services section">


            <div class="container section-title" >
              <span>Services</span>
              <h2>Services</h2>
              <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
            </div>

            <div class="container">

              <div class="row gy-4">

                <div class="col-lg-4 col-md-6" data-aos-delay="100">
                  <div class="service-item  position-relative">
                    <div class="service-card">
                      <div class="icon">
                        <i class="bi bi-activity"></i>
                      </div>

                      <a href="#" class="stretched-link">
                        <h3>Exterior Work</h3>
                      </a>

                      <ul>
                        <small>

                          <li>Customized exterior designs with modern fabrication techniques.
                            Strong structural fabrication for gates, raismallngs, and frameworks.
                            End-to-end civil construction and exterior renovation services.
                            Durable, long-lasting finishes using premium materials.<br /></li>
                          <li>Strong structural fabrication for gates, railings, and architectural frameworks.
                            Durable solutions engineered for safety and aesthetics.<br /></li>
                          <li>Quasmallty workmanship in flooring, plastering, painting, and structural work.
                            Resmallable solutions for residential, commercial, and industrial projects.</li><br />
                        </small>
                      </ul>
                    </div>

                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos-delay="200">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <i class="bi bi-broadcast"></i>
                    </div>
                    <a href="#" class="stretched-link">
                      <h3>Interior Work</h3>
                    </a>

                    <ul>
                      <small>  <li>Elegant living room, modular kitchen, and cozy bedroom designs.

                        Smart storage solutions to maximize space utilization.

                        Customized furniture & décor as per client’s taste.<br /></li>
                        <li>Professional office layouts that boost productivity.

                          Modern retail spaces and showroom interiors to enhance customer experience.

                          Creative designs that balance aesthetics with functionality.<br /></li>
                        <li>Designer ceilings with integrated modern lighting.

                          Mood-based illumination for both homes and workplaces.</li>
                        <li>Premium wall paints, wallpapers, and texture finishes.

                          Wide range of flooring options including wooden, marble, and tiles.</li>
                        <li>Space-saving modular designs.

                          Durable, stylish, and customizable to fit every requirement.</li>
                        <li>Complete end-to-end solutions from design to execution.

                          Hassle-free project management with on-time delivery.</li><br />
                      </small>
                    </ul>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos-delay="300">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <i class="bi bi-easel"></i>
                    </div>
                    <a href="#" class="stretched-link">
                      <h3>Ledo Markt</h3>
                    </a>
                    <p>Ut excepturi voluptatem nisi sed. Quidem fuga consequatur. Minus ea aut. Vel qui id voluptas adipisci eos earum corrupti.</p>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos-delay="400">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <i class="bi bi-bounding-box-circles"></i>
                    </div>
                    <a href="#" class="stretched-link">
                      <h3>Asperiores Commodit</h3>
                    </a>
                    <p>Non et temporibus minus omnis sed dolor esse consequatur. Cupiditate sed error ea fuga sit provident adipisci neque.</p>
                    <a href="#" class="stretched-link"></a>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos-delay="500">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <i class="bi bi-calendar4-week"></i>
                    </div>
                    <a href="#" class="stretched-link">
                      <h3>Velit Doloremque</h3>
                    </a>
                    <p>Cumque et suscipit saepe. Est maiores autem enim facilis ut aut ipsam corporis aut. Sed animi at autem alias eius labore.</p>
                    <a href="#" class="stretched-link"></a>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6" data-aos-delay="600">
                  <div class="service-item position-relative">
                    <div class="icon">
                      <i class="bi bi-chat-square-text"></i>
                    </div>
                    <a href="#" class="stretched-link">
                      <h3>Dolori Architecto</h3>
                    </a>
                    <p>Hic molestias ea quibusdam eos. Fugiat enim doloremque aut neque non et debitis iure. Corrupti recusandae ducimus enim.</p>
                    <a href="#" class="stretched-link"></a>
                  </div>
                </div>

              </div>

            </div>

          </section> */}

          <section id="services" className="services section">

            <div className="container section-title">
              <span>Services</span>
              <h2>Our Services</h2>
              <p>We provide complete exterior, interior, and netting solutions with a blend of design, durability, and functionality.</p>
            </div>

            <div className="container">
              <div className="row gy-4">

                {/* ---- A) Exterior Work ---- */}
                <div className="col-lg-4 col-md-6" data-aos-delay="100">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-building"></i></div>
                    <h3>Design Fabrication</h3>
                    <p>
                      Customized exterior designs that blend style with strength.<br />
                      Modern fabrication techniques for residential, commercial, and industrial projects.<br />
                      Long-lasting finishes with premium materials.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="200">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-tools"></i></div>
                    <h3>Heavy Fabrication Work</h3>
                    <p>
                      Strong structural fabrication for gates, railings, and architectural frameworks.<br />
                      Durable solutions engineered for safety and aesthetics.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="300">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-hammer"></i></div>
                    <h3>Civil Work</h3>
                    <p>
                      End-to-end civil construction and exterior renovation services.<br />
                      Flooring, plastering, painting, and structural development.<br />
                      Reliable solutions for both residential and commercial projects.
                    </p>
                  </div>
                </div>

                {/* ---- B) Interior Work ---- */}
                <div className="col-lg-4 col-md-6" data-aos-delay="400">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-house"></i></div>
                    <h3>Residential Interiors</h3>
                    <p>
                      Elegant living room, modular kitchen, and cozy bedroom designs.<br />
                      Smart storage solutions to maximize space.<br />
                      Customized furniture & décor as per client’s taste.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="500">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-building-check"></i></div>
                    <h3>Commercial Interiors</h3>
                    <p>
                      Professional office layouts that boost productivity.<br />
                      Modern retail and showroom interiors.<br />
                      Creative designs balancing aesthetics with functionality.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="600">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-lightbulb"></i></div>
                    <h3>False Ceiling & Lighting</h3>
                    <p>
                      Designer ceilings with integrated modern lighting.<br />
                      Mood-based illumination for homes and workplaces.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="700">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-bricks"></i></div>
                    <h3>Wall Finishes & Flooring</h3>
                    <p>
                      Premium wall paints, wallpapers, and texture finishes.<br />
                      Wooden, marble, and tile flooring options.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="800">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-cabinet"></i></div>
                    <h3>Modular Furniture & Wardrobes</h3>
                    <p>
                      Space-saving modular designs.<br />
                      Durable, stylish, and customizable furniture solutions.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="900">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-check-circle"></i></div>
                    <h3>Turnkey Interior Projects</h3>
                    <p>
                      Complete end-to-end interior design to execution.<br />
                      Hassle-free project management with on-time delivery.
                    </p>
                  </div>
                </div>

                {/* ---- C) Netting Solutions ---- */}
                <div className="col-lg-4 col-md-6" data-aos-delay="1000">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-shield-lock"></i></div>
                    <h3>Invisible Grill</h3>
                    <p>
                      Modern balcony & window protection.<br />
                      Provides security without blocking the view.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="1100">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-feather"></i></div>
                    <h3>Bird Net</h3>
                    <p>
                      High-quality bird netting solutions.<br />
                      Weather-resistant and long-lasting material.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="1200">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-grid-3x3-gap"></i></div>
                    <h3>Pleated Mosquito Net</h3>
                    <p>
                      Smooth sliding pleated design.<br />
                      Available in stainless steel and glass fiber.<br />
                      Effective protection with stylish looks.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6" data-aos-delay="1300">
                  <div className="service-item position-relative">
                    <div className="icon"><i className="bi bi-window"></i></div>
                    <h3>Aluminium Pleated Net</h3>
                    <p>
                      Lightweight, durable, and easy-to-operate mosquito net system.<br />
                      Enhances convenience while keeping your home pest-free.
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </section>



          <section id="call-to-action" class="call-to-action section dark-background">

            <img src={ctabg} alt="" />

            <div class="container">
              <div class="row justify-content-center" >
                <div class="col-xl-10">
                  <div class="text-center">
                    <h3>Call To Action</h3>
                    <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    <a class="cta-btn" href="#">Call To Action</a>
                  </div>
                </div>
              </div>
            </div>

          </section>

          <section id="portfolio" className="portfolio section">

            <div className="container section-title">
              <span>Portfolio</span>
              <h2>Portfolio</h2>
              <p>Check out some of our recent projects in Exterior, Interior, and Netting Solutions.</p>
            </div>

            <div className="container">
              <div
                className="isotope-layout"
              // data-default-filter="*"
              // data-layout="masonry"
              // data-sort="original-order"
              >
                {/* Filters */}
                {/* <ul className="portfolio-filters isotope-filters" data-aos-delay="100">
                  <li
                    // data-filter="*"
                    className={View === "ALL" ? "filter-active" : ""}
                    onClick={() => setView("ALL")}
                  >
                    All
                  </li>
                  <li
                    // data-filter=".filter-exterior"
                    className={View === "EXT" ? "filter-active" : ""}
                    onClick={() => setView("EXT")}
                  >
                    Exterior Work
                  </li>
                  <li
                    // data-filter=".filter-interior"
                    className={View === "INT" ? "filter-active" : ""}
                    onClick={() => setView("INT")}
                  >
                    Interior Work
                  </li>
                  <li
                    // data-filter=".filter-netting"
                    className={View === "NEW" ? "filter-active" : ""}
                    onClick={() => setView("NEW")}
                  >
                    Netting Solutions
                  </li>
                </ul> */}


                {/* Portfolio Items */}
                <div class="row gy-4 isotope-container" data-aos-delay="200">

                  {(View === "ALL" || View === "EXT") && <>
                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                      <img src={portfolio1} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>App 1</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="/" title="App 1" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>

                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                      <img src={portfolio2} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>Product 1</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="/" title="Product 1" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>

                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                      <img src={portfolio3} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>Branding 1</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="/" title="Branding 1" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>
                  </>}
                  {(View === "ALL" || View === "INT") && <>
                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                      <img src={portfolio4} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>App 2</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="/" title="App 2" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>

                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                      <img src={portfolio5} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>Product 2</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="/" title="Product 2" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>

                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                      <img src={portfolio6} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>Branding 2</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="/" title="Branding 2" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>
                  </>}
                  {(View === "ALL" || View === "NEW") && <>

                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                      <img src={portfolio7} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>App 3</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="/"
                          title="App 3" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>

                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                      <img src={portfolio8} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>Product 3</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="/" title="Product 3" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>

                    <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                      <img src={portfolio9} class="img-fluid" alt="" />
                      {/* <div class="portfolio-info">
                        <h4>Branding 3</h4>
                        <p>Lorem ipsum, dolor sit</p>
                        <a href="assets/img/masonry-portfolio/masonry-portfolio-9.jpg" title="Branding 2" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                        <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                      </div> */}
                    </div>
                  </>}


                  {/* You can duplicate above blocks for more projects */}

                </div>
              </div>
            </div>
          </section>



          {/* <section id="portfolio" class="portfolio section">


            <div class="container section-title" >
              <span>Portfolio</span>
              <h2>Portfolio</h2>
              <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
            </div>

            <div class="container">

              <div class="isotope-layout" data-default-filter="*" data-layout="masonry" data-sort="original-order">

                <ul class="portfolio-filters isotope-filters" data-aos-delay="100">
                  <li data-filter="*" class="filter-active">All</li>
                  <li data-filter=".filter-app">App</li>
                  <li data-filter=".filter-product">Card</li>
                  <li data-filter=".filter-branding">Web</li>
                </ul>

                <div class="row gy-4 isotope-container" data-aos-delay="200">

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                    <img src={portfolio1} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>App 1</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="/" title="App 1" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                    <img src={portfolio2} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>Product 1</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="/" title="Product 1" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                    <img src={portfolio3} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>Branding 1</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="/" title="Branding 1" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                    <img src={portfolio4} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>App 2</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="/" title="App 2" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                    <img src={portfolio5} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>Product 2</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="/" title="Product 2" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                    <img src={portfolio6} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>Branding 2</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="/" title="Branding 2" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                    <img src={portfolio7} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>App 3</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="/"
                        title="App 3" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                    <img src={portfolio8} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>Product 3</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="/" title="Product 3" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                  <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                    <img src={portfolio9} class="img-fluid" alt="" />
                    <div class="portfolio-info">
                      <h4>Branding 3</h4>
                      <p>Lorem ipsum, dolor sit</p>
                      <a href="assets/img/masonry-portfolio/masonry-portfolio-9.jpg" title="Branding 2" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                      <a href="/" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                    </div>
                  </div>

                </div>

              </div>

            </div>





          </section> */}


          {/*   <section id="pricing" class="pricing section">


            <div class="container section-title" >
              <span>Pricing</span>
              <h2>Pricing</h2>
              <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
            </div>

            <div class="container">

              <div class="row g-4 g-lg-0">

                <div class="col-lg-4" data-aos-delay="100">
                  <div class="pricing-item">
                    <h3>Free Plan</h3>
                    <h4><sup>$</sup>0<span> / month</span></h4>
                    <ul>
                      <li><i class="bi bi-check"></i> <span>Quam adipiscing vitae proin</span></li>
                      <li><i class="bi bi-check"></i> <span>Nec feugiat nisl pretium</span></li>
                      <li><i class="bi bi-check"></i> <span>Nulla at volutpat diam uteera</span></li>
                      <li class="na"><i class="bi bi-x"></i> <span>Pharetra massa massa ultricies</span></li>
                      <li class="na"><i class="bi bi-x"></i> <span>Massa ultricies mi quis hendrerit</span></li>
                    </ul>
                    <div class="text-center"><a href="#" class="buy-btn">Buy Now</a></div>
                  </div>
                </div>

                <div class="col-lg-4 featured" data-aos-delay="200">
                  <div class="pricing-item">
                    <h3>Business Plan</h3>
                    <h4><sup>$</sup>29<span> / month</span></h4>
                    <ul>
                      <li><i class="bi bi-check"></i> <span>Quam adipiscing vitae proin</span></li>
                      <li><i class="bi bi-check"></i> <span>Nec feugiat nisl pretium</span></li>
                      <li><i class="bi bi-check"></i> <span>Nulla at volutpat diam uteera</span></li>
                      <li><i class="bi bi-check"></i> <span>Pharetra massa massa ultricies</span></li>
                      <li><i class="bi bi-check"></i> <span>Massa ultricies mi quis hendrerit</span></li>
                    </ul>
                    <div class="text-center"><a href="#" class="buy-btn">Buy Now</a></div>
                  </div>
                </div>

                <div class="col-lg-4" data-aos-delay="100">
                  <div class="pricing-item">
                    <h3>Developer Plan</h3>
                    <h4><sup>$</sup>49<span> / month</span></h4>
                    <ul>
                      <li><i class="bi bi-check"></i> <span>Quam adipiscing vitae proin</span></li>
                      <li><i class="bi bi-check"></i> <span>Nec feugiat nisl pretium</span></li>
                      <li><i class="bi bi-check"></i> <span>Nulla at volutpat diam uteera</span></li>
                      <li><i class="bi bi-check"></i> <span>Pharetra massa massa ultricies</span></li>
                      <li><i class="bi bi-check"></i> <span>Massa ultricies mi quis hendrerit</span></li>
                    </ul>
                    <div class="text-center"><a href="#" class="buy-btn">Buy Now</a></div>
                  </div>
                </div>

              </div>

            </div>

          </section> 
          
          
          <section id="team" class="team section">


            <div class="container section-title" >
              <span>Team</span>
              <h2>Team</h2>
              <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
            </div>

            <div class="container">

              <div class="row">

                <div class="col-lg-4 col-md-6 d-flex" data-aos-delay="100">
                  <div class="member">
                    <img src={team1} class="img-fluid" alt="" />
                    <div class="member-content">
                      <h4>Walter White</h4>
                      <span>Web Development</span>
                      <p>
                        Magni qui quod omnis unde et eos fuga et exercitationem. Odio veritatis perspiciatis quaerat qui aut aut aut
                      </p>
                      <div class="social">
                        <a href=""><i class="bi bi-twitter-x"></i></a>
                        <a href=""><i class="bi bi-facebook"></i></a>
                        <a href=""><i class="bi bi-instagram"></i></a>
                        <a href=""><i class="bi bi-linkedin"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 d-flex" data-aos-delay="200">
                  <div class="member">
                    <img src={team2} class="img-fluid" alt="" />
                    <div class="member-content">
                      <h4>Sarah Jhinson</h4>
                      <span>Marketing</span>
                      <p>
                        Repellat fugiat adipisci nemo illum nesciunt voluptas repellendus. In architecto rerum rerum temporibus
                      </p>
                      <div class="social">
                        <a href=""><i class="bi bi-twitter-x"></i></a>
                        <a href=""><i class="bi bi-facebook"></i></a>
                        <a href=""><i class="bi bi-instagram"></i></a>
                        <a href=""><i class="bi bi-linkedin"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 d-flex" data-aos-delay="300">
                  <div class="member">
                    <img src={team3} class="img-fluid" alt="" />
                    <div class="member-content">
                      <h4>William Anderson</h4>
                      <span>Content</span>
                      <p>
                        Voluptas necessitatibus occaecati quia. Earum totam consequuntur qui porro et laborum toro des clara
                      </p>
                      <div class="social">
                        <a href=""><i class="bi bi-twitter-x"></i></a>
                        <a href=""><i class="bi bi-facebook"></i></a>
                        <a href=""><i class="bi bi-instagram"></i></a>
                        <a href=""><i class="bi bi-linkedin"></i></a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </section> */}


          <section id="contact" class="contact section">


            <div class="container section-title" >
              <span>Contact</span>
              <h2>Get In Touch</h2>
              <p>We would love to hear from you! Share your requirements and our team will connect with you shortly.</p>
            </div>

            <div class="container" data-aos-delay="100">

              <div class="row gy-4">

                <div class="col-lg-6">
                  <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos-delay="200">
                    <i class="bi bi-geo-alt"></i>
                    <h3>Address</h3>
                    <a
                      href="https://www.google.com/maps?q=Abhishek+complex,+Makarpura+GIDC,+Vadodara,+390010"
                      target="_blank"
                      rel="noopener noreferrer"
                    >

                      <p>Abhishek complex, Makarpura GIDC, Vadodara, 390010</p>
                    </a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos-delay="300">
                    <i class="bi bi-telephone"></i>
                    <h3>Call Us</h3>
                    <p><span><a href={`tel:704-399-2106`}>+91 704-399-2106</a></span></p>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos-delay="400">
                    <i class="bi bi-envelope"></i>
                    <h3>Email Us</h3>
                    <p><a href="mailto:info@creativeexterior.in">info@creativeexterior.in</a></p>
                  </div>
                </div>

              </div>

              {/* <div class="row gy-4 mt-1">
                <div class="col-lg-6" data-aos-delay="300">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d48389.78314118045!2d-74.006138!3d40.710059!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a22a3bda30d%3A0xb89d1fe6bc499443!2sDowntown%20Conference%20Center!5e0!3m2!1sen!2sus!4v1676961268712!5m2!1sen!2sus" frameborder="0"
                    // style="border:0; width: 100%; height: 400px;"
                    allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>

                <div class="col-lg-6">
                  <form action="forms/contact.php" method="post" class="php-email-form" data-aos-delay="400">
                    <div class="row gy-4">

                      <div class="col-md-6">
                        <input type="text" name="name" class="form-control" placeholder="Your Name" required="" />
                      </div>

                      <div class="col-md-6 ">
                        <input type="email" class="form-control" name="email" placeholder="Your Email" required="" />
                      </div>

                      <div class="col-md-12">
                        <input type="text" class="form-control" name="subject" placeholder="Subject" required="" />
                      </div>

                      <div class="col-md-12">
                        <textarea class="form-control" name="message" rows="6" placeholder="Message" required=""></textarea>
                      </div>

                      <div class="col-md-12 text-center">
                        <div class="loading">Loading</div>
                        <div class="error-message"></div>
                        <div class="sent-message">Your message has been sent. Thank you!</div>

                        <button type="submit">Send Message</button>
                      </div>

                    </div>
                  </form>
                </div>

              </div> */}

            </div>

          </section>

        </main>

        <footer id="footer" class="footer position-relative dark-background">

          <div class="container footer-top">
            <div class="row gy-4">
              <div class="col-lg-4 col-md-6">
                <div class="footer-about">
                  {/* <a href="index/" class="logo sitename">Day</a> */}
                  <div class="footer-contact pt-3">
                    <a
                      href="https://www.google.com/maps?q=Abhishek+complex,+Makarpura+GIDC,+Vadodara,+390010"
                      target="_blank"
                      rel="noopener noreferrer"
                    >

                      <p>Abhishek complex</p>
                      <p>Makarpura GIDC, Vadodara, 390010</p>
                    </a>
                    <p class="mt-3"><strong>Phone:</strong> <span><a href={`tel:704-399-2106`}>+91 704-399-2106</a></span></p>
                    <p><strong>Email:</strong> <a href="mailto:info@creativeexterior.in">info@creativeexterior.in</a></p>
                  </div>
                  <div class="social-links d-flex mt-4">
                    {/* <a href=""><i class="bi bi-twitter-x"></i></a> */}
                    <a href="https://www.facebook.com/share/1MBeAe9MDv/"><i class="bi bi-facebook"></i></a>
                    <a href="https://www.instagram.com/creativeexterior/"><i class="bi bi-instagram"></i></a>
                    {/* <a href=""><i class="bi bi-linkedin"></i></a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-2 col-md-3 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li><a href="#">Home</a></li>
                  <li><a href="#">About us</a></li>
                  <li><a href="#">Services</a></li>
                  {/* <li><a href="#">Terms of service</a></li>
                  <li><a href="#">Privacy policy</a></li> */}
                </ul>
              </div>

              <div class="col-lg-2 col-md-3 footer-links">
                <h4>Our Services</h4>
                <ul>
                  <li><a href="#">Exterior Work</a></li>
                  <li><a href="#">Interior Work</a></li>
                  <li><a href="#">Netting Solutions</a></li>
                </ul>
              </div>

              {/* <div class="col-lg-4 col-md-12 footer-newsletter">
                <h4>Our Newsletter</h4>
                <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
                <div class="newsletter-form"><input type="email" name="email" /><input type="submit" value="Subscribe" /></div>
                <div class="loading">Loading</div>
                <div class="error-message"></div>
                <div class="sent-message">Your subscription request has been sent. Thank you!</div>
              </div> */}

            </div>
          </div>
          {/* 
          <div class="container copyright text-center mt-4">
            <p>© <span>Copyright</span> <strong class="px-1 sitename">Day</strong> <span>All Rights Reserved</span></p>
            <div class="credits">




              Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
            </div>
          </div> */}

        </footer>


        <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>


        {/* <div id="preloader"></div> */}

      </body>
    </div >
  );
}

export default App;
